/* eslint-disable no-template-curly-in-string */
import { Button, SelectWithLabel } from 'components/Form'
import TextInputField from 'components/Form/TextInputField'
import ModalWrapper from 'components/ModalWrapper'
import React, { useEffect, useState } from 'react'
import { I18n } from 'react-redux-i18n'
import { getStaticImage } from 'utils/statics'
import './styles.scss'
const _ = require('lodash')

const lang = (text) => I18n.t(text)

const NormalModal = (props) => {
  const { mailProvider, isOpen, toggle, onSubmit, onChange: onChangeExternal, schema, channel } = props
  const [ state, setState ] = useState({ email: '', timeFrame: '', isEqualImapSmtp: true, imap: { user: "", password: "" } })
  const [ stateError, setStateError ] = useState({ email: '', timeFrame: '', imap: { user: "", password: "" } })
  const [ isSubmitting, setIsSubmitting ] = useState(false)
  const errorRequiredField = lang('dashboard_errors_required-field')
  const optionsTimeFrame = schema?.schema?.timeFrame?.options.map(it => ({ value: it.value, label: lang(it.label) })) || []
  const [currentStep, setCurrentStep] = useState(1)

  useEffect(() => {
    if (channel.value) {
      let _state = _.clone(state)
      if (channel?.value?.email) _.set(_state, 'email', channel.value.email)
      if (channel?.value?.timeFrame) _.set(_state, 'timeFrame', channel.value.timeFrame)
      if (channel?.value?.imap?.user) _.set(_state, 'imap.user', channel.value.imap.user)
      if (channel?.value?.imap?.password) _.set(_state, 'imap.password', channel.value.imap.password)
      setState(_state)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [channel.value])

  useEffect(() => {
    let _stateError = _.clone(stateError)
    if (state?.email) _.set(_stateError, 'email', '')
    if (state?.timeFrame) _.set(_stateError, 'timeFrame', '')
    if (state.imap.user) _.set(_stateError, 'imap.user', '')
    if (state.imap.password) _.set(_stateError, 'imap.password', '')
    
    setStateError(_stateError)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state])

  const onSave = async () => {
    let error = false

    let _stateError = _.clone(stateError)
    if (!state.email) {
      _.set(_stateError, 'email', errorRequiredField)
      error = true
    }
    
    if (!state.imap.user) {
      _.set(_stateError, 'imap.user', errorRequiredField)
      error = true
    }
    if (!state.imap.password) {
      _.set(_stateError, 'imap.password', errorRequiredField)
      error = true
    }
    if (!state.timeFrame) {
      _.set(_stateError, 'timeFrame', errorRequiredField)
      error = true
    }
    if (error) {
      setStateError(_stateError)
      return
    }
    setIsSubmitting(true)
    try {
      const result = await onSubmit()
      setIsSubmitting(false)
      if (result?._id) {
        toggle()
      }
    } catch (error) {
      setIsSubmitting(false)
    }
  }

  const onChange = (field, value) => {
    const _state = _.clone(state)
    _.set(_state, field, value)

    if (field === 'email') {
      _.set(_state, 'imap.user', value)
    }
    if (field === 'password') {
      _.set(_state, 'imap.password', value)
    }
    
    setState(_state)
    onChangeExternal(_state)
  }

  return (
    <ModalWrapper
      id={'modalAccountNormal'}
      header=' '
      body={
        mailProvider
          ?
          <div className='delegate-wrapper normal-modal'>
            <div className='steps-indicator'>
              <ul className=''>
                <li className={`number-wrapper ${currentStep === 1 ? 'current' : 'checked'}`}>
                  <div className='line-separator'></div>
                  <div className='number'>
                    {
                      currentStep === 1
                        ?
                        1
                        :
                        <img src={getStaticImage('/icons/orange-brand/icon-check.svg')} alt='icon'/>
                    }
                    
                  </div>
                  <p>{lang('channels_config_imap_create_password')}</p>
                </li>
                <li className={`number-wrapper ${currentStep === 2 ? 'current' : ''}`}>
                  <div className='number'>
                    {2}
                  </div>
                  <p>{lang('dashboard_authenticate')}</p>
                </li>
              </ul>
            </div>
            {
              currentStep === 1
                ?
                <div className='stepOne'>
                  <h2>
                    {lang('channels_config_imap_title').replace('${maillabel}', mailProvider.label)}
                  </h2>
                  <div className='stepOne-items'>
                    <div className='wrapper-literals'>
                      <div className='literals' dangerouslySetInnerHTML={{ __html: lang('channels_config_imap_first').replace('${maillabel}', mailProvider.label).replace('${mailhelp}', mailProvider.help) }}>
                      </div>
                      <Button
                        secondary
                        className={''}
                        value={lang('channels_config_imap_button').replace('${maillabel}', mailProvider.label)}
                        onClick={()=> {
                          window.open(mailProvider.link, "_blank")
                        }}
                      />
                      <div className='literals' dangerouslySetInnerHTML={{ __html: lang('channels_config_imap_second') }}></div>
                    </div>
                    <img className='image-help' src={getStaticImage(`/banner_help_${mailProvider.key}.png`)} alt={mailProvider.key} />
                  </div>
                </div>
                :
                <div className='stepTwo'>
                  <h2>
                    {lang('channels_config_imap_title2')}
                  </h2>
                  <TextInputField
                    label={lang('dashboard_email')}
                    value={state.email}
                    placeholder={lang('channels_field_email_placeholder')}
                    onChange={(value) => onChange('email', value)}
                    errorMessage={stateError.email}
                  />

                  <TextInputField
                    label={lang('dashboard_password')}
                    value={state.imap.password}
                    placeholder={'********'}
                    onChange={(value) => onChange('imap.password', value)}
                    type='password'
                    errorMessage={stateError.imap.password}
                  />

                  <div className='delegate-select-wrapper'>
                    <label className='label-select'>{lang('dashboard_import')}</label>
                    <SelectWithLabel
                      placeholder={lang('dashboard_select')}
                      options={optionsTimeFrame}
                      onChange={(value) => onChange('timeFrame', value.value)}
                      value={optionsTimeFrame.find(it => it.value === state.timeFrame) || ''}
                    />
                    {stateError?.timeFrame && <span className='error-message'>{stateError?.timeFrame}</span>}
                  </div>
                </div>
            }
            <div className='seccion-buttons'>
              <Button
                className={'button-back'}
                value={lang('dashboard_previous')}
                onClick={()=>{
                  if (currentStep === 1) toggle()
                  else setCurrentStep(currentStep - 1)
                }}
              />
              <Button
                secondary
                className={''}
                value={lang('dashboard_continue')}
                onClick={()=> {
                  if (currentStep === 2) onSave()
                  else setCurrentStep(currentStep + 1)
                }}
                isSubmitting={isSubmitting}
              />
            </div>
            {/* <img className={`delegate-image`} alt={mailProvider.key} src={getStaticImage(`/icons/orange-brand/icon-${mailProvider.key === 'imap_yahoo' ? 'yahoo' : mailProvider.key === 'imap_icloud' ? 'icloud' : mailProvider.key === 'imap_aol' ? 'aol' : mailProvider.key}.png`)}/>
            <h2>{`${lang('dashboard_add-account-of')} ${mailProvider.label}`}</h2>

            <div className='section-fields'>
              <TextInputField
                label={lang('dashboard_email')}
                value={state.email}
                placeholder={lang('channels_field_email_placeholder')}
                onChange={(value) => onChange('email', value)}
                errorMessage={stateError.email}
              />

              <TextInputField
                label={lang('dashboard_password')}
                value={state.imap.password}
                placeholder={'********'}
                onChange={(value) => onChange('imap.password', value)}
                type='password'
                errorMessage={stateError.imap.password}
              />

              <div className='delegate-select-wrapper'>
                <label className='label-select'>{lang('dashboard_import')}</label>
                <SelectWithLabel
                  placeholder={lang('dashboard_select')}
                  options={optionsTimeFrame}
                  onChange={(value) => onChange('timeFrame', value.value)}
                  value={optionsTimeFrame.find(it => it.value === state.timeFrame) || ''}
                />
                {stateError?.timeFrame && <span className='error-message'>{stateError?.timeFrame}</span>}
              </div>

              <Button secondary className={'add-account-button'} value={lang('dashboard_next')} onClick={onSave} isSubmitting={isSubmitting} />

            </div> */}
            
          </div>
          :
          null
      }
      isOpen={isOpen}
      toggle={()=>{
        setCurrentStep(1)
        toggle()
      }}
      showClose={true}
    />
  )
}

export default NormalModal
